document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-size-guide-open]');
  if (opener) {
    const dialog = document.getElementById(opener.dataset.sizeGuideOpen);
    if (dialog && !dialog.open) dialog.showModal();
    return;
  }
  const close = event.target.closest('[data-size-guide-close]');
  if (close) close.closest('dialog').close();
  if (event.target.matches('.ls-size-guide-dialog')) {
    const box = event.target.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
  }
});
